import { apiCall } from '../helpers/apiHelpers';
import { ApiResult } from '../types/api/common';
import { RenewalDraftResponse } from '../types/api/responses';

interface RenewalDraftParams {
  sessionId: string;
  company: string;
  agreementId: string;
}

export const renewalDraftService = ({ sessionId, company, agreementId }: RenewalDraftParams): Promise<ApiResult<RenewalDraftResponse>> =>
  apiCall<RenewalDraftResponse>({
    method: 'GET',
    url: `/client/renewal-draft?agreementId=${agreementId}&company=${company}&clientSessionId=${sessionId}`,
  })();
